module.exports = __webpack_public_path__ + "static/img/63-2.55052d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/63-2.jpg
// module id = tRuO
// module chunks = 0